import type { LoadTypeFormData } from "@/features/adp/schemas/LoadType";
import type { OutputPreviewFormValues } from "@/features/adp/schemas/OutputPreview";
import type {
  CreateTargetResponse,
  TargetTablesBatchBody,
} from "@/features/adp/services/destination/destination.types";
import { isOutputPreviewStringType } from "./outputPreview.utils";

export function mapLoadTypeToCode(loadType: LoadTypeFormData["loadType"]): 1 | 2 {
  return loadType === "full" ? 1 : 2;
}

export function mapScdTypeToCode(scdType: string): 1 | 2 {
  return scdType.trim().toUpperCase() === "SCD1" ? 1 : 2;
}

type BuildTargetTableBatchPayloadInput = {
  targetData: CreateTargetResponse;
  /** Optional: when absent (e.g. Excel destination skips the load-type step), codes default to 1. */
  loadTypeForm?: LoadTypeFormData;
  outputPreviewValues: OutputPreviewFormValues;
};

export function buildTargetTableBatchPayload(
  input: BuildTargetTableBatchPayloadInput,
): TargetTablesBatchBody {
  const { targetData, loadTypeForm, outputPreviewValues } = input;

  const loadTypeCode: 1 | 2 = loadTypeForm ? mapLoadTypeToCode(loadTypeForm.loadType) : 1;
  const scdTypeCode: 1 | 2 = loadTypeForm ? mapScdTypeToCode(loadTypeForm.scdType) : 1;

  return {
    target_table: [
      {
        data_source_name: targetData.source_name,
        table_name: targetData.table_name,
        target_table_type: "",
        path: targetData.path,
        glue_table_name: "",
        load_type_code: loadTypeCode,
        scd_type_code: scdTypeCode,
      },
    ],
    target_table_column: outputPreviewValues.columns
      .filter((c) => c.selected)
      .map((c) => ({
        table_name: targetData.table_name,
        column_name: c.fieldName,
        column_data_type: c.fieldDataType,
        column_length: String(
          isOutputPreviewStringType(c.fieldDataType) ? c.fieldLength : 0,
        ),
        precision: 0,
        is_business_primary_key: c.isPrimaryKey,
      })),
  };
}
